import React, { RefObject } from "react";

type FileUploadButtonProps = {
  fileRef: React.RefObject<HTMLInputElement | null>;
  handleChange: () => void;
  handleButtonClick: () => void;
  title?: string;
  mode?: string;
};

export const FileUploadButton: React.FC<FileUploadButtonProps> = ({
  fileRef,
  handleChange,
  handleButtonClick,
  title,
  mode,
}) => {
  return (
    <label htmlFor="file-upload">
      <input
        className="form-control w-100 d-none"
        type="file"
        id="file-upload"
        ref={fileRef}
        onChange={handleChange}
        multiple
      />
      <button
        onClick={handleButtonClick}
        type="button"
        className="btn btn-outline-secondary"
      >
        {title}
      </button>
    </label>
  );
};
